<template>
  <b-alert
    show
    variant="info"
  >
    <div class="alert-body">
      <feather-icon
        class="mr-25"
        icon="InfoIcon"
      />
      <span class="ml-25">
        نقش‌ها و دسترسی‌های کاربران از این پس در پنل <strong>Dash</strong> مدیریت می‌شوند
        و هر تغییری در آن‌جا خودکار در اتوماسیون اعمال می‌شود.
      </span>
      <a
        v-if="dashUsersUrl"
        :href="dashUsersUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="ml-25 font-weight-bold"
      >ورود به پنل Dash</a>
      <div
        v-if="roles"
        class="mt-50"
      >
        <small class="mr-25">نقش‌های فعلی کاربر:</small>
        <b-badge
          v-for="role in roles"
          :key="role"
          variant="light-primary"
          class="mr-25"
        >
          {{ role }}
        </b-badge>
        <small v-if="roles.length === 0">بدون نقش</small>
      </div>
    </div>
  </b-alert>
</template>

<script>
import { BAlert, BBadge } from 'bootstrap-vue'

/**
 * Where an admin changes roles and permissions now. Set VUE_APP_DASH_URL to
 * link there; without it the notice only explains.
 */
const dashUrl = (process.env.VUE_APP_DASH_URL || '').replace(/\/+$/, '')

export default {
  name: 'ManagedInDashNotice',
  components: {
    BAlert,
    BBadge,
  },
  props: {
    /**
     * Names of the roles the user holds now, shown read-only. Left out, no
     * roles are shown.
     */
    roles: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      dashUsersUrl: dashUrl ? `${dashUrl}/dash/users` : null,
    }
  },
}
</script>
